import { ReactNode } from 'react';

export type DropdownItemProps = {
  children: ReactNode;
  clickHandler: () => void;
  className?: string;
};

export const DropdownItem = ({ children, clickHandler, className }: DropdownItemProps) => {
  return (
    <hot-dropdown-menu-item slot="menu" className={className} onClick={clickHandler}>
      {children}
    </hot-dropdown-menu-item>
  );
};
